<template>
  <b-row class="mt-2">

    <b-col cols="12" md="6">
      <b-form-group :label="$t('Container Name')" label-for="vi-name-id">
        <b-input-group class="input-group-merge">
          <b-form-input
              v-model="requestData.name" id="vi-name-id"
              :state="errors && ('name' in errors) ? false : null"
              :placeholder="$t('Container Name')"
          />
        </b-input-group>
        <small v-if="errors && ('name' in errors)" class="text-danger">
          {{ $t(errors['name'][0]) }}
        </small>
      </b-form-group>
    </b-col>

    <b-col cols="12" md="6">
      <b-form-group :label="$t('Container Code')" label-for="vi-code-id">
        <b-input-group class="input-group-merge">
          <b-form-input
              v-model="requestData.code" id="vi-code-id"
              :state="errors && ('code' in errors) ? false : null"
              :placeholder="$t('Container Code')"
          />
        </b-input-group>
        <small v-if="errors && ('code' in errors)" class="text-danger">
          {{ $t(errors['code'][0]) }}
        </small>
      </b-form-group>
    </b-col>

    <!-- tag number -->
    <b-col cols="12" md="6">
      <b-form-group :label="$t('Tag Number')" label-for="vi-tag">
        <b-input-group class="input-group-merge">
          <b-form-input
              v-model="requestData.tag"
              :state="errors && ('tag' in errors) ? false : null"
              id="vi-tag"
              :placeholder="$t('Tag Number')"
          />
        </b-input-group>
        <small v-if="errors && ('tag' in errors)" class="text-danger">
          {{ $t(errors['tag'][0]) }}
        </small>
      </b-form-group>
    </b-col>

    <!-- owner  -->
    <b-col cols="12" md="6">
      <b-form-group
          :label="$t('Container Owner')"
          label-for="vi-owner-id">
        <v-select
            v-model="requestData.owner_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :getOptionLabel="o => o.name"
            :options="owners"
            :reduce="owner => owner.id"
        />
        <small v-if="errors && ('owner_id' in errors)" class="text-danger">
          {{ $t(errors['owner_id'][0]) }}
        </small>
      </b-form-group>
    </b-col>



<!--    &lt;!&ndash; category  &ndash;&gt;-->

<!--    <b-col cols="12" md="6">-->
<!--      <b-form-group-->
<!--          :label="$t('Container Category')"-->
<!--          label-for="vi-category-id">-->
<!--        <v-select-->
<!--            :state="null"-->
<!--            v-model="requestData.category"-->
<!--            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
<!--            :options="categories"-->
<!--            @input="getTypesByCategory($event)"-->
<!--        />-->
<!--        <small v-if="errors && ('category' in errors)" class="text-danger">-->
<!--          {{ $t(errors['category'][0]) }}-->
<!--        </small>-->
<!--      </b-form-group>-->
<!--    </b-col>-->


    <!-- type  -->
    <b-col cols="12" md="6">
      <b-form-group :label="$t('Container Type')">
        <v-select
            v-model="requestData.type_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :getOptionLabel="t => t.name"
            :options="types"
            :reduce="type => type.id"
        />
        <span class="invalid-feedback"> error </span>
        <small v-if="errors && ('type_id' in errors)" class="text-danger">
          {{ $t(errors['type_id'][0]) }}
        </small>
      </b-form-group>
    </b-col>

<!--    &lt;!&ndash; group  &ndash;&gt;-->
<!--    <b-col cols="12" md="6">-->
<!--      <b-form-group :label="$t('Container Group')" label-for="vi-group-id">-->
<!--        <v-select-->
<!--            v-model="requestData.group_id"-->
<!--            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
<!--            :getOptionLabel="g => g.name"-->
<!--            :options="groups"-->
<!--            :reduce="group => group.id"-->
<!--        />-->
<!--        <small v-if="errors && ('group_id' in errors)" class="text-danger">-->
<!--          {{ $t(errors['group_id'][0]) }}-->
<!--        </small>-->
<!--      </b-form-group>-->
<!--    </b-col>-->


    <!-- contract  -->
    <b-col cols="12" md="6">
      <b-form-group :label="$t('Container Contract')" label-for="vi-contract-id">
        <v-select
            v-model="requestData.contract_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :getOptionLabel="t => t.name"
            :options="contracts"
            :reduce="contract => contract.id"
        />
        <small v-if="errors && ('contract_id' in errors)" class="text-danger">
          {{ $t(errors['contract_id'][0]) }}
        </small>
      </b-form-group>
    </b-col>

  </b-row>
</template>

<script>
import { getUserLinkedBy } from '@/api/userLinkedData'
import { OrbitSpinner } from 'epic-spinners'
import vSelect from 'vue-select'
import { ref, toRefs, watch } from '@vue/composition-api'
import store from '@/store'
import RfidForm from '@/views/modules/rfid/components/Form'
import { BButton, BCard, BCol, BForm, BFormGroup, BFormInput,
  BInputGroup, BRow, BAlert, BTabs, BTab, BCardText, BTable, BPagination
} from 'bootstrap-vue'



export default {
  name: 'ContainerForm',
  props: ['requestData', 'errors'],
  components: { RfidForm, BRow, BCard, BCol, BAlert, BTable,BPagination,
    BFormGroup, BFormInput, BInputGroup, BForm, BButton, BTabs, BCardText, BTab, vSelect, OrbitSpinner
  },

  setup(props) {

    const auth = store.state.auth.userData

    const owners = ref([])
    const contracts = ref([])
    const types = ref([])


    getUserLinkedBy({ type: 'user', user: auth.id }).then(r =>
        owners.value = r.data.data)

    getUserLinkedBy({ type: 'contract', user: auth.id }).then(r =>
        contracts.value = r.data.data)

    store.dispatch('container/getTypesOptionsBy', 'CONTAINER')
        .then(r => types.value = r.data.data).catch(r => {})

    const getTypesByCategory = cat => {
      store.dispatch('container/getTypesOptionsBy', 'CONTAINER')
          .then(r => types.value = r.data.data).catch(r => {})
    }

    const request = toRefs(props).requestData

    watch(request, r => {
      getTypesByCategory(r.category)
    })

    return {
      owners,
      contracts,
      types,
      getTypesByCategory

    }

  }
}
</script>

<style scoped>

</style>
